import { render } from "./WelcomeModal.vue?vue&type=template&id=be24ee92&scoped=true"
import script from "./WelcomeModal.vue?vue&type=script&lang=js"
export * from "./WelcomeModal.vue?vue&type=script&lang=js"

import "./WelcomeModal.vue?vue&type=style&index=0&id=be24ee92&scoped=true&lang=css"
import "./WelcomeModal.vue?vue&type=style&index=1&id=be24ee92&lang=css"

import exportComponent from "/vercel/path0/shinai/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be24ee92"]])

export default __exports__